// ============================================================
// FILE: resources/js/config/axios.js
// USPATIH GO — Axios Global Configuration
// ============================================================

import axios from 'axios';
import { clearUserClientState, isPanelPath } from '../utils/sessionCleanup.js';
import { reportClientError, resolveAndReportError } from '../helpers/userFacingError.js';

// ---- Default Headers ----------------------------------------
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['Accept'] = 'application/json';
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.withCredentials = true;

// ---- CSRF Token (untuk web routes) --------------------------
const csrfMeta = document.head.querySelector('meta[name="csrf-token"]');
if (csrfMeta) {
  axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfMeta.content;
}

// ---- Bearer token: selalu baca fresh dari localStorage ----
axios.interceptors.request.use((config) => {
  // FormData: hapus application/json agar browser set multipart + boundary.
  if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
    const headers = config.headers;
    if (headers && typeof headers.set === 'function') {
      headers.set('Content-Type', false);
    } else if (headers) {
      delete headers['Content-Type'];
      delete headers['content-type'];
      if (headers.common) {
        delete headers.common['Content-Type'];
        delete headers.common['content-type'];
      }
    }
  }

  if (isPanelPath()) {
    delete config.headers.common?.Authorization;
    delete config.headers.Authorization;
    return config;
  }

  const token = localStorage.getItem('uspatih_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete config.headers.common?.Authorization;
    delete config.headers.Authorization;
  }
  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    if (status === 401 && !isPanelPath()) {
      const hadToken = !!localStorage.getItem('uspatih_token');
      if (hadToken) {
        clearUserClientState();
        if (window.Alpine?.store('auth')) {
          window.Alpine.store('auth').user = null;
          window.Alpine.store('auth').token = null;
        }
      }
    }

    // Sematkan pesan aman agar toast(e.response?.data?.message) tidak bocor
    const safe = resolveAndReportError(error);
    if (error.response?.data && typeof error.response.data === 'object') {
      error.response.data.message = safe;
      delete error.response.data.exception;
      delete error.response.data.file;
      delete error.response.data.line;
      delete error.response.data.trace;
    } else if (!error.response) {
      reportClientError({
        message: error.message || 'network_error',
        source: 'axios_network',
        stack: error.stack,
      });
      error.message = safe;
    }

    return Promise.reject(error);
  },
);

if (!isPanelPath()) {
  const bootToken = localStorage.getItem('uspatih_token');
  if (bootToken) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${bootToken}`;
  }
}

export const API_BASE = window.APP_URL ? `${window.APP_URL}/api/v1` : '/api/v1';

export default axios;
